import PropTypes from 'prop-types';
import React from 'react';

import {
  TextField,
  Button,
} from '@material-ui/core';
import {CloudFunctionsClient} from '../../CloudFunctionsClient';

class StripePayout extends React.Component {
  constructor(props) {
    super(props);
    
    this.state = {
      amount: 0,
      description: '',

      isLoading: false,
      isInstantTransfer: true,
    }
  }

  submitStripePayout = async(e) => {
    e.preventDefault();

    this.setState({
      isLoading: true,
    })

    const {amount, description, isInstantTransfer} = this.state;
    const {userId} = this.props;

    try {
      await CloudFunctionsClient.post(
        '/rangerPayout-transferToStripeConnectAccount', {amount, userId, description, isInstantTransfer});

      this.setState({
        amount: 0,
        description: '',
        isLoading: false,
      });
    } catch (e) {
      console.error(e);

      this.setState({
        isLoading: false,
      });
    }

  }

  render() {
    const {amount, isLoading, description, isInstantTransfer} = this.state;
    const disableSubmit = isLoading || amount <= 0;

    return (
      <div>
        <h3>Create New Payout</h3>

        <form onSubmit={this.submitStripePayout}>
          <TextField
            label="Description"
            disabled={isLoading}
            type="text"
            value={description}
            onChange={(e) => this.setState({description: e.target.value})}
            className="m-2" 
          />

          <TextField
            label="Amount"
            helperText="Amount in cents."
            disabled={isLoading}
            type="number"
            value={amount}
            onChange={(e) => this.setState({amount: e.target.value})}
            className="m-2" 
          />

          <div className="form-check">
            <label className="form-check-label-bold">
              <input
                type="checkbox"
                checked={isInstantTransfer}
                className="form-check-input"
                onChange={() => this.setState({
                  isInstantTransfer: !isInstantTransfer,
                })}
              /> Instant Transfer
            </label>
          </div>

          <div>
            <Button type="submit" color="primary" variant="outlined" disabled={disableSubmit}>
              Payout
            </Button>
          </div>
        </form>
      </div>
    )
  }
}

StripePayout.propTypes = {
  userId: PropTypes.string.isRequired,
}

export {StripePayout};



// WEBPACK FOOTER //
// ./src/street-team/member-profile/StripePayout.js